import React from "react";
import Modal from "react-modal";
import Loader from "../../containers/Loader";

const CartPaymentPopup = ({
  transactionInProgress,
  setShowModal,
  showModal,
}) => {
  return (
    <Modal
      isOpen={showModal}
      contentLabel="Payment Processing"
      className="custom-modal"
      overlayClassName="custom-modal-overlay"
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
    >
      {transactionInProgress ? (
        <div style={{ textAlign: "center" }}>
          <h5>Processing Your Order...</h5>
          <p style={{ color: "#666", marginTop: "10px" }}>
            Please don't close this window.
          </p>
          <Loader />
        </div>
      ) : (
        <div style={{ textAlign: "center" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="green"
            width="66px"
            height="66px"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path d="M12 0C5.37 0 0 5.37 0 12s5.37 12 12 12 12-5.37 12-12S18.63 0 12 0zm-1 17.93l-4.24-4.24 1.41-1.41 2.83 2.83 6.59-6.59 1.41 1.41L11 17.93z" />
          </svg>
          <h5 className="mt-2">Order Placed Successfully!</h5>
          <p style={{ color: "#666", marginTop: "10px" }}>
            Redirecting to home...
          </p>
        </div>
      )}
    </Modal>
  );
};

export default CartPaymentPopup;
